<template>
    <div v-if="isVisible" class="offline-error">
        <div class="offline-icon">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="20" cy="20" r="20" fill="#373737"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.9397 28.2377C22.1432 28.0342 22.2818 27.7749 22.338 27.4926C22.3942 27.2103 22.3653 26.9177 22.2552 26.6518C22.145 26.3858 21.9585 26.1585 21.7192 25.9986C21.4799 25.8387 21.1985 25.7534 20.9107 25.7534C20.6228 25.7534 20.3414 25.8387 20.1021 25.9986C19.8628 26.1585 19.6763 26.3858 19.5661 26.6518C19.456 26.9177 19.4271 27.2103 19.4833 27.4926C19.5395 27.7749 19.6781 28.0342 19.8816 28.2377C20.1545 28.5106 20.5247 28.6639 20.9107 28.6639C21.2966 28.6639 21.6668 28.5106 21.9397 28.2377ZM26.4349 13.7586C26.4481 13.7633 26.4624 13.7641 26.476 13.7609C26.4896 13.7577 26.5021 13.7507 26.5118 13.7407L28.684 11.5685C28.7581 11.4945 28.8461 11.4359 28.9429 11.396C29.0397 11.3561 29.1435 11.3357 29.2482 11.3359C29.9648 11.3359 30.3071 12.2019 29.8123 12.6967L14.8403 27.6689C14.7662 27.7429 14.6782 27.8015 14.5814 27.8414C14.4846 27.8813 14.3808 27.9017 14.2761 27.9014C13.5594 27.9014 13.2173 27.0353 13.7119 26.5406L16.1328 24.1198C16.1414 24.1114 16.1478 24.101 16.1515 24.0895C16.1551 24.078 16.1558 24.0658 16.1535 24.0539C16.1249 23.8926 16.1437 23.7265 16.2078 23.5757C16.2718 23.425 16.3783 23.2961 16.5142 23.2047C16.8696 22.9639 17.2443 22.7529 17.6344 22.5737L17.7253 22.5273L20.9802 19.2725C20.9907 19.2621 20.9978 19.2487 21.0007 19.2341C21.0036 19.2196 21.002 19.2045 20.9963 19.1908C20.9906 19.1771 20.9809 19.1654 20.9685 19.1573C20.9562 19.1491 20.9416 19.1448 20.9268 19.1449C18.8914 19.1572 16.9033 19.759 15.2027 20.8775C15.0263 20.9944 14.8124 21.0408 14.6034 21.0075C14.3944 20.9742 14.2056 20.8637 14.0742 20.6978L14.0177 20.627C13.9437 20.5352 13.8898 20.4289 13.8594 20.3151C13.829 20.2012 13.8229 20.0822 13.8413 19.9658C13.8597 19.8493 13.9024 19.7381 13.9664 19.6391C14.0305 19.5402 14.1146 19.4558 14.2133 19.3914C16.7249 17.7394 19.7529 17.0602 22.7295 17.4812C22.741 17.483 22.7527 17.482 22.7638 17.4783C22.7748 17.4746 22.7847 17.4684 22.7928 17.46L24.963 15.2899C24.9722 15.2806 24.9789 15.2691 24.9823 15.2564C24.9857 15.2437 24.9857 15.2304 24.9824 15.2177C24.979 15.2051 24.9723 15.1935 24.963 15.1842C24.9538 15.175 24.9422 15.1683 24.9296 15.1649C22.8861 14.6134 20.7494 14.4985 18.6586 14.8277C16.5678 15.157 14.5698 15.923 12.7948 17.0759C12.6144 17.1934 12.396 17.2378 12.184 17.2002C11.972 17.1626 11.7823 17.0458 11.6533 16.8734L11.6101 16.8155C11.3015 16.404 11.4012 15.8535 11.815 15.5838C13.9549 14.193 16.3826 13.3061 18.9151 12.99C21.4476 12.6738 24.0188 12.9366 26.4349 13.7586ZM21.8646 21.9461L20.2667 23.5441C20.2559 23.5551 20.2487 23.569 20.2461 23.5842C20.2435 23.5993 20.2456 23.6149 20.2522 23.6288C20.2587 23.6427 20.2694 23.6542 20.2827 23.6618C20.2961 23.6695 20.3114 23.6728 20.3267 23.6714C21.7263 23.536 23.1295 23.8911 24.2963 24.6758C24.464 24.7903 24.6674 24.8404 24.8691 24.8167C25.0708 24.793 25.2571 24.6972 25.3937 24.5469C25.6037 24.3184 25.7101 24.1257 25.673 23.808C25.6613 23.6864 25.6223 23.569 25.5589 23.4645C25.4956 23.3601 25.4095 23.2713 25.3071 23.2047C24.2957 22.5203 23.1382 22.082 21.9272 21.9249C21.9158 21.9232 21.9042 21.9243 21.8934 21.928C21.8825 21.9317 21.8727 21.9379 21.8647 21.9461L21.8646 21.9461ZM25.5399 18.2708L24.2653 19.5455C24.2563 19.5546 24.2497 19.5658 24.2462 19.5781C24.2427 19.5904 24.2424 19.6034 24.2454 19.6158C24.2484 19.6282 24.2545 19.6397 24.2632 19.6491C24.2718 19.6585 24.2828 19.6655 24.2949 19.6695C25.1794 19.9594 26.0214 20.3657 26.7988 20.8775C27.4688 21.3186 28.267 20.6504 28.1582 19.9659C28.1416 19.8491 28.0999 19.7373 28.0361 19.6381C27.9722 19.5389 27.8876 19.4548 27.7881 19.3914C27.1052 18.9414 26.3792 18.5606 25.6208 18.2545C25.6072 18.2488 25.5923 18.2473 25.5779 18.2503C25.5634 18.2532 25.5502 18.2604 25.5399 18.2709L25.5399 18.2708ZM27.7235 16.2264C28.2337 16.481 28.729 16.7646 29.2067 17.0759C29.8842 17.5173 30.6794 16.8337 30.5573 16.1452C30.5391 16.0306 30.4966 15.9212 30.4327 15.8244C30.3687 15.7275 30.2847 15.6455 30.1864 15.5838C29.7981 15.3307 29.4119 15.1009 29.0052 14.8812C28.9911 14.8734 28.9748 14.8705 28.9588 14.8728C28.9428 14.8751 28.9281 14.8826 28.9168 14.8941L27.7042 16.1068C27.6957 16.1151 27.6894 16.1254 27.6858 16.1367C27.6821 16.1479 27.6812 16.1599 27.6831 16.1717C27.685 16.1834 27.6897 16.1945 27.6967 16.204C27.7038 16.2136 27.713 16.2213 27.7236 16.2266L27.7235 16.2264Z" fill="white"/>
          </svg>
        </div>
        <p class="text-message text-color-white">You are offline. Some features may not be available.</p>
        <button class="close-btn" @click="closeError">x</button>
    </div> 
</template>

<script setup>
import { ref, watch, defineProps } from "vue";

const props = defineProps({
  isOffline: {
    type: Boolean,
    required: true,
  },
});

const isVisible = ref(false);
watch(
  () => props.isOffline,
  (newVal) => {
    isVisible.value = newVal;
  },
  { immediate: true }
);

const closeError = () => {
  isVisible.value = false;
};
</script>

<style scoped>
.offline-error {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #1C1C1C;
  display: flex;
  align-items: center;
  font-size: 14px;
  z-index: 10000; /* Ensure it stays above other components */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  width: 540px;
  height: 59px;
  flex-shrink: 0;
}

.close-btn {
  background: none;
  border: none;
  color: #fff;
  font-size: 21px;
  cursor: pointer;
  margin-left: 36px;
}
.text-color-white {
  color: white;
}
.text-message{
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    margin-left: 20px;
}
.offline-icon{
   margin-left: 10px; 
}
</style>